import { render, staticRenderFns } from "./MenuSearchPalette.vue?vue&type=template&id=61de44aa"
import script from "./MenuSearchPalette.vue?vue&type=script&lang=js"
export * from "./MenuSearchPalette.vue?vue&type=script&lang=js"
import style0 from "./MenuSearchPalette.vue?vue&type=style&index=0&id=61de44aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports